import { combineReducers } from 'redux';
import { ReducerStoreProps } from '@mvf/product-components/redux';
import { loadingBarReducer } from './LoadingBar/loadingBarReducer';

export const featuresReducer = combineReducers({
  loadingBar: loadingBarReducer,
});

export type IFeatureStore = ReducerStoreProps<typeof featuresReducer>;
